<template>
  <div class="section-roles section-5" ref="roles">
    <div class="bg img-box">
      <img v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/bg.png'">
    </div>
    <div v-if="heroes && heroes.length != 0" class="hero-introduce">
      <div
        class="hero-container"
        v-for="hero in heroes"
        :key="hero.name"
        :class="[hero.name]"
        v-show="hero.name == subHeroName"
      >
        <div class="bg-role">
          <div
            class="specialty-box specialty-roleBgBox img-box"
            v-for="(item, key) in lg(hero, 'specialty', [])"
            :key="key"
          >
            <img v-show="item.id == lg(hero, 'subHeroID', '')" v-lazy="lg(item, 'lie_bg', '')">
          </div>
        </div>
        <div class="role">
          <div
            class="specialty-box specialty-roleBox"
            v-for="(item, key) in lg(hero, 'specialty', [])"
            :key="key"
            :class="item.id"
          >
            <div v-show="item.id == lg(hero, 'subHeroID', '')" class="specialty-role">
              <div v-if="lg(item, 'spine', '')" class="role-spine" :id="lg(item, 'spine.appendEleID', '')"></div>
              <div v-else class="vertical img-box">
                <img v-lazy="lg(item, 'lie', '')">
              </div>
            </div>
          </div>
        </div>
        <div class="skill">
          <div class="name-box">
            <div v-if="lang == 'cn'" class="name-abb">{{ hero.name.toUpperCase() }}</div>
            <div v-else class="name-abb">{{ subLocale[`${hero.name}_before`] }}</div>
            <div class="name">{{ subLocale[hero.name] }}</div>
            <!-- <div class="line img-box">
              <img v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/line.png'" alt="">
            </div> -->
            <!-- <div class="name-ch">{{ subLocale[`${hero.name}_before`] }}</div> -->
          </div>
          <div class="video-box">
            <img class="video-frame" v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/video_frame.png'">
            <div class="video">
              <xd-video
                v-for="(item, i) in lg(hero, 'specialty', [])"
                :key="i"
                :name="`video_${item.id}`"
                class="video-autoplay"
                :ref="`video_${lg(item, 'id', '')}`"
                :options="{
                  controls: true,
                  loop: true,
                  autoplay: false,
                  video: lg(item, 'video', ''),
                  poster: lg(item, 'video_poster', '')
                }"
                v-show="item.id == lg(hero, 'subHeroID', '')"
              />
            </div>
          </div>
          <div class="hero-introduction">
            <div class="title">{{ subLocale['intro_title'] }}</div>
            <div class="introduction">
              <span
                v-for="(item, key) in lg(hero, 'specialty', [])"
                :key="key"
                v-show="item.id == lg(hero, 'subHeroID', '')"
              >{{ subLocale[`${lg(item, 'intro', '')}`] }}</span>
            </div>
          </div>
          <div class="skill-container">
            <div
              v-for="(item, key) in lg(hero, 'specialty', [])"
              :key="key"
              class="specialty-box specialty-skillBox"
              :class="{ active: item.id == lg(hero, 'subHeroID', '') }"
              @click="switchHero(subHeroName, item.id)"
            >
              <div class="icon-box">
                <div class="icon img-box">
                  <img v-lazy="lg(item, 'icon', '')" />
                </div>
                <img
                  class="default"
                  v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/skill_default_btn.png'"
                />
                <img
                  class="active"
                  v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/skill_active_btn.png'"
                />
              </div>
              <p>{{ subLocale[`${lg(item, 'skill', '')}`] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hero-switch">
      <div class="icon-left img-box" @click="prevHero">
        <img v-lazy="'https://website.xdcdn.net/poster/172664/homepage/BEuiuKlP.png'">
      </div>
      <div class="hero-switch-container">
        <ul class="btns">
          <li
            v-for="(hero, i) in slicedHeroes"
            :key="i"
            :name="hero.name"
            :class="{ active: subHeroName == hero.name }"
            @click="switchHero(hero.name, lg(hero, 'subHeroID', ''), i)"
          >
            <div class="icon">
              <div class="default">
                <img v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/switch_default_btn.png'">
              </div>
              <div class="active">
                <img v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/switch_active_btn.png'">
              </div>
            </div>
            <span>{{ subLocale[`${hero.name}_before`] }}</span>
          </li>
        </ul>
      </div>
      <div class="icon-right img-box" @click="nextHero">
        <img v-lazy="'https://website.xdcdn.net/poster/172664/homepage/BEuiuKlP.png'">
      </div>
    </div>
  </div>
</template>

<script>
import createSpine from "../libs/spine/index.js";
import * as initAnime from "../libs/initAnimePc";
import XdVideo from "../components/xdvideo.vue";
import _lg from '../libs/lg'

// let url_pre = "https://poster.xdcdn.net/xd-website/homepage/torchlight";

export default {
  props: {
    heroes: {
      type: Array,
      default: () => [],
    },
    subHeroName: {
      type: String,
      default: () => "",
    },
    subHeroID: {
      type: String,
      default: () => "",
    },
    subLocale: {
      type: Object,
      default: () => {}
    },
    lang: {
      type: String
    }
  },
  components: { XdVideo },
  data() {
    return {
      spineController: {},
      videoList: {},
      switchStep: {
        start: 2,
        length: 0,
        total: 5,
        step: 0,
        stepWidth: -13.7
      },
      startSliceIndex: 0,
      showCount: 8,
      switchTimer: '',
      inSwitch: false,
      lg: _lg
    };
  },
  computed: {
    subHeroSpecialty() {
      if(!this.heroes) {
        return {};
      }else {
        let subHero = this.heroes.find(item => item.name == this.subHeroName);
        return subHero.specialty.find(item => item.id == this.subHeroID);
      }
    },
    slicedHeroes() {
      if(!this.heroes) {
        return [];
      }
      if (this.heroes.length < this.showCount) {
        return this.heroes;
      }else {
        return this.heroes.slice(this.startSliceIndex, this.startSliceIndex + this.showCount);
      }
    }
  },
  watch: {
    heroes: {
      handler(newVal, oldVal) {
        if (newVal != oldVal && newVal.length != 0) {
          this.$nextTick(() => {
            this.initTransitions();
          });
        }
      },
      immediate: true,
      deep: true,
    },
    subHeroID: {
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal && newVal != oldVal) {
          this.playSpine(this.subHeroSpecialty);
          // this.$nextTick(() => {
            // this.playVideo();
          // })
        }
      }
    },
  },
  methods: {
    initTransitions() {
      let transitions = {};
      this.heroes.forEach((hero) => {
        transitions[hero.name] = initAnime.introduce('.section-roles', hero);
      });

      // 初始化完成，播放默认英雄动画
      transitions[this.subHeroName] && transitions[this.subHeroName].restart();
      this.$emit("init-transitions-end", transitions);
    },
    playVideo() {
      this.$refs[`video_${this.subHeroID}`] && this.$refs[`video_${this.subHeroID}`][0].play();
    },
    playSpine(hero) {
      let spineControllerKeys = Object.keys(this.spineController);
      // 每次切换spine, 都要暂停其他spine，释放缓存
      spineControllerKeys.forEach(key => {
        this.spineController[key].stop();
      })

      if(spineControllerKeys.includes(hero.id)) {
        this.spineController[hero.id].start();
      }else {
        // 如果有spine的配置，则初始化
        if(hero.spine) {
          this.initSpine(hero);
        }
      }
    },
    initSpine(hero) {
      if(!hero.spine) return;
      createSpine(hero.spine)
        .then((spine) => {
          document.getElementById(hero.spine.appendEleID).appendChild(spine.view);
          this.spineController[hero.id] = spine;

          if (this.subHeroID == hero.id) {
            spine.start();
          }
        });
    },
    switchHero(name, id='', i='') {
      if(!this.inSwitch) {
        this.inSwitch = true;

        this.$emit('switch-hero', { name, id })
        // if(typeof i == 'number') {
        //   this.handleStep(i+1);
        // };

        this.switchTimer = setTimeout(() => {
          this.inSwitch = false;
          this.playVideo();
        }, 1700)
      }
    },
    prevHero() {
      let thisHero = this.heroes.find(item => item.name == this.subHeroName);
      let thisIndex = this.heroes.indexOf(thisHero);
      if(thisIndex >= 1) {
        let prevIndex = thisIndex - 1;
        let prevHero = this.heroes[prevIndex];
        const isExist = this.slicedHeroes.find((item) => item.name == prevHero['name']);
        if (!isExist) {
          this.startSliceIndex = prevIndex;
        }
        this.switchHero(prevHero['name'], prevHero['subHeroID'], prevIndex);
      }
    },
    nextHero() {
      let thisHero = this.heroes.find(item => item.name == this.subHeroName);
      let thisIndex = this.heroes.indexOf(thisHero);
      if(thisIndex < this.heroes.length - 1) {
        let nextIndex = thisIndex + 1;
        let nextHero = this.heroes[nextIndex];
        const isExist = this.slicedHeroes.find((item) => item.name == nextHero['name']);
        if (!isExist) {
          this.startSliceIndex += 1;
        }
        this.switchHero(nextHero['name'], nextHero['subHeroID'], nextIndex);
      }
    },
    handleStep(i) {
      if(!this.switchStep['length']) {
        this.switchStep['length'] = this.heroes.length
      }

      let index_start = i - this.switchStep['start'];
      if(index_start > 0) {
        let length_total = this.switchStep['length'] - this.switchStep['total'];
        if(index_start <= length_total) {
          this.switchStep['step'] = index_start;
        }else {
          this.switchStep['step'] = length_total;
        }
      }else {
        this.switchStep['step'] = 0;
      }
    }
  },
};
</script>


<style lang="scss" scoped>
@import '../scss/mixin.scss';
@import '../scss/files.scss';

.img-box {
  display: flex;
  justify-content: center;
  img {
    // width: 100%;
    height: 100%;
  }
}

.section-roles {
  position: relative;
  overflow: hidden;
  height: vwPc(1271px, $ratio: 1);
  clip-path: polygon(0% 0%, 100% 0%, 100% 82.6%, 0% 100%);

  >.bg {
    position: absolute;
    width: 100%;
    height: vwPc(1415px);
    bottom: 0;
    left: 0;
  }

  .hero-introduce {
    position: relative;
    width: vwPc(1920px, $ratio: 1);
    height: 100%;
    margin: 0 auto;

    .hero-container {
      position: relative;
      width: 100%;
      height: 100%;
      .bg-role {
        transform-origin: right bottom;
        width: vwPc(1126px);
        height: vwPc(2210px);
        position: absolute;
        bottom: vwPc(116px, $ratio: 1);
        right: vwPc(-1px, $ratio: 1);
        @include gpu-for-transition();
        .specialty-box {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }
      .role {
        position: absolute;
        bottom: -1px;
        right: 0;
        width: vwPc(1400px, $ratio: 1);
        height: vwPc(970px, $ratio: 1);
        transform-origin: center bottom;
        .specialty-box {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          .specialty-role {
            width: 100%;
            height: 100%;
            @include gpu-for-transition();
          }
        }
        canvas {
          width: 100% !important;
          height: 100% !important;
        }
        .role-spine {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        .vertical {
          width: 100%;
          height: 100%;
        }
      }
      .decorate-line {
        &[name="1"] {
          width: 16.35417vw;
          height: 27.96875vw;
          position: absolute;
          top: 0px;
          left: vwPc(235px, $ratio: 1);

          &.animete {
            animation: decorate_line1 linear 4s infinite;
          }

          @keyframes decorate_line1 {
            from {
              transform: translate(16vw, -27.71281vw);
            }
            to {
              transform: translate(-34vw, 58.88973vw);
            }
          }
        }
        &[name="2"] {
          width: 5.83333vw;
          height: 9.73958vw;
          position: absolute;
          top: 0px;
          left: vwPc(300px, $ratio: 1);

          &.animete {
            animation: decorate_line2 linear 6s infinite;
          }

          @keyframes decorate_line2 {
            from {
              transform: translate(-5vw, 8.66025vw);
            }
            to {
              transform: translate(30vw, -51.96152vw);
            }
          }
        }
      }
      .skill {
        position: absolute;
        bottom: vwPc(210px);
        left: vwPc(1217px);
        width: vwPc(735px);
        .name-box {
          display: inline-block;
          position: relative;
          color: #fff;
          transform: translate3d(0, 0, 0);
          .name-abb {
            font-size: vwPc(50px);
            transform: matrix(1, 0, -0.22, 0.98, 0, 0);
            position: absolute;
            top: vwPc(-55px);
            right: 0;
            font-weight: bolder;
            white-space: nowrap;
          }
          .name {
            font-size: vwPc(160px);
            transform: matrix(1, 0, -0.15, 0.98, 0, 0);
            white-space: nowrap;
            font-weight: bolder;
            line-height: 1.1;
          }
        }
        .video-box {
          position: relative;
          width: vwPc(735px);
          height: vwPc(464px);
          transform: translate3d(0, 0, 0);
          .video {
            width: vwPc(728px);
            height: vwPc(408px);
            position: absolute;
            top: vwPc(3px);
            left: vwPc(3px);
            clip-path: polygon(0% 0%, 100% 0%, 100% 83%, 93% 100%, 0% 100%);
            background-color: black;
            padding-top: 0;
            .video-autoplay {
              width: 100%;
              height: 100%;
              padding: 0;
            }
          }
          .video-frame {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .hero-introduction {
          color: #fff;
          margin-top: vwPc(-40px);
          min-height: vwPc(230px);
          transform: translate3d(0, 0, 0);
          .title {
            font-size: vwPc(38px);
            font-weight: bold;
          }
          .introduction {
            font-size: vwPc(28px);
            white-space: pre-wrap;
          }
        }
        .skill-container {
          margin: 0 auto;
          padding-top: vwPc(15px, $ratio: 1);
          overflow: hidden;
          display: flex;
          justify-content: center;
          .specialty-box {
            width: vwPc(107px, $ratio: 1);
            margin: 0 vwPc(20px);
            -webkit-tap-highlight-color: transparent;
            transform: translate3d(0, 0, 0);
            .icon-box {
              position: relative;
              width: vwPc(122px);
              height: vwPc(122px);
              cursor: pointer;
              margin: 0 auto;
              >.default {
                width: 100%;
                height: 100%;
                position: absolute;
                top:0;
                left: 0;
                transition: all ease-in-out 200ms;
              }
              >.active {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0px;
                opacity: 0;
                transition: all ease-in-out 200ms;
              }

              .icon {
                width: vwPc(94px);
                height: vwPc(94px);
                position: absolute;
                left: 50%;
                top: 50%;
                margin-left: vwPc(-47px);
                margin-top: vwPc(-47px);
              }
            }
            p {
              text-align: center;
              color: #fff;
              font-size: vwPc(14px, $ratio: 1);
              font-weight: bold;
              margin-top: vwPc(15px);
            }

            &.active {
              .icon-box {
                .active {
                  opacity: 1;
                }
                .default {
                  opacity: 0;
                }
              }
            }
          }
        }
      }

      &.rehan {
        #rehanSpine {
          left: 14vw;
          top: -6.5vw;
        }
        #rehan2Spine {
          left: 1vw;
          top: -6.5vw;
        }
      }
      &.carino {
        #carinoSpine {
          left: -6vw;
          top: -2vw;
        }
        #carino2Spine {
          left: 9vw;
          top: 8vw;
        }
      }
      &.gemma {
        #gemmaSpine {
          left: 3vw;
          top: -6vw;
        }
        #gemma4Spine {
          left: 3vw;
          top: -7vw;
        }
        #gemma2Spine {
          left: 6vw;
          top: -6vw;
        }
      }
      &.moto {
        #motoSpine {
          left: 7vw;
          top: -6vw;
        }
        #moto2Spine {
          left: 6vw;
          top: -6vw;
        }
      }
      &.youga {
        #yougaSpine {
          left: 11vw;
          top: -4vw;
        }
        .youga_2 {
          .img-box {
            width: vwPc(1750px, $ratio: 1);
            height: vwPc(776px, $ratio: 1);
            position: absolute;
            top: 3.5vw;
            left: -6vw;
          }
        }
      }
      &.thea {
        #theaSpine {
          left: 9vw;
          top: -6vw;
        }
        #thea2Spine {
          left: 12vw;
          top: -3vw;
        }
      }
      &.erika {
        #erikaSpine {
          left: 3vw;
        }
      }
      &.bing {
        #bingSpine {
          left: 2vw;
          top: -7vw;
        }
      }
    }
  }

  .hero-switch {
    position: absolute;
    width: vwPc(36px);
    height: vwPc(925px);
    bottom: vwPc(180px);
    right: vwPc(2685px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .icon-left {
      width: vwPc(42px);
      height: vwPc(42px);
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: scale(1.2);
      }
      margin-bottom: vwPc(20px);
    }
    .icon-right {
      width: vwPc(42px);
      height: vwPc(42px);
      cursor: pointer;
      transition: all 0.3s;
      transform: rotate(180deg);
      margin-top: vwPc(20px);
      &:hover {
        transform: scale(1.2) rotate(180deg);
      }
    }
    .hero-switch-container {
      width: 100%;
      height: vwPc(925px);
      .btns {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: all ease-in-out 100ms;

        li {
          position: relative;
          cursor: pointer;
          height: vwPc(28px);
          color: #D7D6D6;
          font-size: vwPc(58px);
          font-weight: bolder;
          -webkit-tap-highlight-color: transparent;
          .icon {
            position: relative;
            width: vwPc(36px);
            height: vwPc(28px);
            .default {
              width: 100%;
              height: 100%;
              img {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
              }
            }
            .active {
              width: vwPc(43px);
              height: vwPc(45px);
              position: absolute;
              top: 50%;
              margin-top: vwPc(-22.5px);
              left: 50%;
              margin-left: vwPc(-23px);
              visibility: hidden;
              opacity: 0;
              transform: translate3d(-0.5vw, 0, 0);
              img {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
              }
            }

            &::before {
              content: '';
              width: vwPc(2px);
              height: vwPc(100px);
              position: absolute;
              left: 48%;
              margin-left: vwPc(-1px);
              top: vwPc(28px);
              background-color: #fff;
            }
          }
          span {
            display: inline-block;
            position: absolute;
            top: 50%;
            margin-top: vwPc(-38px);
            right: vwPc(50px);
            height: vwPc(70px);
            white-space: nowrap;
            transition: all ease-in-out 300ms;
          }


          &:last-child {
            .icon {
              &::before {
                display: none;
              }
            }
          }



          &.active {
            .icon {
              .default {
                visibility: hidden;
                opacity: 0;
              }
              .active {
                visibility: visible;
                opacity: 1;
                transition: all ease-in-out 300ms;
                transform: translate3d(0, 0, 0);
              }
            }
            span {
              color: #FFCA19;
            }
          }

          &:hover {
            span {
              transform: translate3d(get_vw(-5px), 0, 0);
            }
          }
        }
      }
    }
  }
}
</style>
